/* NEVERSAD: barra de envío gratis + productos sugeridos en carrito y ventana de "agregado". */
(function () {
  if (window.__nvCartBoost) return;
  window.__nvCartBoost = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-CO');
  }

  function renderFreeShipping(cart) {
    document.querySelectorAll('[data-nv-fs]').forEach(function (el) {
      var threshold = parseInt(el.dataset.threshold, 10) || 30000000;
      var total = cart.total_price;
      var left = threshold - total;
      var msg = el.querySelector('.nv-fs__msg');
      var bar = el.querySelector('.nv-fs__bar');
      if (cart.item_count === 0) {
        msg.innerHTML = 'Envío gratis en compras desde ' + money(threshold);
      } else if (left > 0) {
        msg.innerHTML = 'Te faltan <b>' + money(left) + '</b> para tener <b>envío gratis</b>';
      } else {
        msg.innerHTML = '<b>¡Tienes envío gratis!</b>';
      }
      el.classList.toggle('is-free', cart.item_count > 0 && left <= 0);
      if (bar) bar.style.width = Math.min(100, (total / threshold) * 100) + '%';
    });
  }

  function renderRecs(cart) {
    var boxes = document.querySelectorAll('[data-nv-recs]');
    if (!boxes.length) return;
    if (!cart.items.length) { boxes.forEach(function (b) { b.hidden = true; }); return; }
    var inCart = cart.items.map(function (i) { return i.product_id; });
    var seed = cart.items[0].product_id;
    fetch(root + 'recommendations/products.json?product_id=' + seed + '&limit=8')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.products || []).filter(function (p) {
          return p.available && inCart.indexOf(p.id) === -1;
        });
        boxes.forEach(function (box) {
          var limit = parseInt(box.dataset.limit, 10) || 3;
          var list = box.querySelector('.nv-recs__list');
          var picks = products.slice(0, limit);
          if (!picks.length) { box.hidden = true; return; }
          list.innerHTML = picks.map(function (p) {
            var img = p.featured_image || '';
            if (img && img.indexOf('?') === -1) img += '?width=160'; else if (img) img += '&width=160';
            return '<a class="nv-rec" href="' + p.url + '">' +
              (img ? '<img src="' + img + '" alt="" loading="lazy" width="64" height="64">' : '') +
              '<span class="nv-rec__info"><span class="nv-rec__name">' + p.title.replace(/</g, '&lt;') + '</span>' +
              '<span class="nv-rec__price">' + money(p.price) + '</span></span>' +
              '<span class="nv-rec__cta">Ver talla</span></a>';
          }).join('');
          box.hidden = false;
        });
      })
      .catch(function () {});
  }

  function refresh() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderFreeShipping(cart); renderRecs(cart); })
      .catch(function () {});
  }

  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refresh, 150); }).catch(function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();
